import styled from 'styled-components';

export const StyledBanner = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor === 'Grey'
      ? theme.palette.lightBackground
      : theme.palette.white};

  padding: 0;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const FileImage = styled.div`
  min-width: 112px;
  min-height: 158px;
  background-image: ${({ $image }) => `url(${$image})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
`;

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing.standard};
  padding-left: ${({ theme, $paddingLeft }) =>
    $paddingLeft ? theme.spacing.standard : 0};
`;
